// import * as THREE from 'three';
import type { NoiseConfig } from '@/types/terrain'
import { createNoise2D, NoiseFunction2D } from 'simplex-noise';
import alea from 'alea';


export class NoiseGenerator {
    private noise: NoiseFunction2D;

    constructor(config: NoiseConfig) {
        const seed = config.seed ?? Date.now();
        this.noise = createNoise2D(alea(seed));
    }

    /**
     * 단일 노이즈 값 생성
     * @param {number} x - X 좌표
     * @param {number} y - Y 좌표
     * @param {number} scale - 노이즈 스케일 (작을수록 더 빠르게 변화)
     * @returns {number} -1 ~ 1 사이의 값
     */
    getNoise(x: number, y: number, scale: number = 0.1): number {
        return this.noise(x * scale, y * scale);    // -1.0 ~ 1.0
    }

    /**
     * 0 ~ 1 범위로 정규화된 노이즈
     * @param {number} x - X 좌표
     * @param {number} y - Y 좌표
     * @param {number} scale - 노이즈 스케일
     * @returns {number} 0 ~ 1 사이의 값
     */
    getNoiseNormalized(x: number, y: number, scale: number = 0.1): number {
        return (this.getNoise(x, y, scale) + 1) / 2.0;  // 0 ~ 1.0
    }

    /**
     * Fractal Brownian Motion
     * @param {number} x - X 좌표
     * @param {number} y - Y 좌표
     * @param {number} scale - 기본 스케일
     * @param {number} octaves - 옥타브 수
     * @param {number} persistence - 진폭 감소율 (0~1)
     * @param {number} lacunarity - 주파수 증가율 (>1)
     * @returns {number} -1 ~ 1 사이의 값
     */
    getFBM(x: number, y: number, scale = 0.1, octaves = 4, persistence = 0.5, lacunarity = 0.5): number {

        let value: number = 0;
        let amplitude: number = 1.0;
        let frequency: number = scale;
        let maxValue: number = 0.0;

        for (let i = 0; i < octaves; ++i) {
            const noiseValue = this.noise(x * frequency, y * frequency);

            value += (noiseValue * amplitude);
            maxValue += amplitude;

            amplitude *= persistence;
            frequency *= lacunarity;
        }

        return value / maxValue;
    }

    /**
     * 0 ~ 1 범위로 정규화된 FBM
     */
    getFBMNormalized(x: number, y: number, scale = 0.1, octaves = 4, persistence = 0.5, lacunarity = 2.0): number {
        return (this.getFBM(x, y, scale, octaves, persistence, lacunarity) + 1) / 2;
    }
}